import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faAlignLeft, // Top logo (use a news-related icon)
	faMicrophone, // Concise
	faMobileAlt, // Simple UI
	faBell, // Daily Updates
} from "@fortawesome/free-solid-svg-icons";
import { faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import SimpleWrapper from "../components/SimpleWrapper";

const features = [
	{
		icon: faMicrophone,
		title: "Concise",
		desc: "Quick, Crisp News.",
	},
	{
		icon: faMobileAlt,
		title: "Simple UI",
		desc: "Read Easily, Anytime.",
	},
	{
		icon: faBell,
		title: "Daily Updates",
		desc: "Fresh News Every Day.",
	},
];

export default function BitesInfo() {
	return (
		<SimpleWrapper searchVisible={false} navigation={false}>
			<div className='w-full flex flex-col items-center pt-8 pb-12 mt-2 bg-white'>
				{/* Logo */}
				<div className='flex justify-center items-center mb-4'>
					<img
						src='/assets/bites-logo.png'
						alt='Bites Logo'
						className='w-[80px] h-[75px]'
					/>
				</div>

				{/* Title & Desc */}
				<div className='w-full flex flex-col items-center text-center mb-2'>
					<h2 className='text-[24px] font-semibold text-[#212232] mb-2'>
						Bites – News In 50 Words (By Fine Labs)
					</h2>
					<p className='text-[#747681] text-[16px] md:text-[16px] font-normal '>
						Your daily dose of top news in just 50 words.
						<br className='hidden md:block' />
						Bites is an innovative news app by Fine Labs, delivering curated
						news summaries across politics, business, sports, entertainment, and
						world updates – all within 50 words. Stay informed without scrolling
						endlessly.
					</p>
				</div>

				{/* Why Bites */}
				<section className='w-full max-w-5xl mx-auto flex flex-col items-center mt-8 mb-12 px-4'>
					<h3 className='text-[24px] md:text-[28px] font-semibold text-[#212232] mb-4 text-center'>
						Why Bites?
					</h3>
					{/* Mobile: Column; Desktop: Row */}
					<div className='flex flex-col md:flex-row gap-2 md:gap-14 w-full justify-center items-center'>
						{features.map(({ icon, title, desc }) => (
							<div
								key={title}
								className='
              w-full w-[260px] h-[80px]  md:w-[260px]
              flex flex-row 
              items-center md:items-center
              gap-4 md:gap-8
              px-4 py-4 md:px-0 md:py-0 bg-white
              rounded-xl
              shadow-none
            '>
								<div className='flex-shrink-0 bg-[#0047AF] rounded-2xl w-14 h-14 flex items-center justify-center '>
									<FontAwesomeIcon
										icon={icon}
										className='text-white text-2xl'
									/>
								</div>
								<div className='flex flex-col items-start md:mt-4 md:text-center'>
									<div className='font-semibold text-[#212232] text-[17px] md:text-base mb-1'>
										{title}
									</div>
									<div className='text-[#747681] text-[14px] md:text-sm text-center font-normal'>
										{desc}
									</div>
								</div>
							</div>
						))}
					</div>
				</section>
				{/* Download App */}
				<div className='flex flex-col items-center  mb-2'>
					<span className='font-semibold text-[24px] text-[#212232] mb-3'>
						Download Bites App
					</span>
					<button className='flex items-center bg-[#222] rounded-lg '>
						<img
							src='/assets/google-pay.png'
							alt='Google Play'
							className='w-[162px] h-[48px]'
						/>
					</button>
					<span className='text-[#747681] text-sm mt-2'>
						Coming Soon On Google Play
					</span>
				</div>

				{/* Footer text */}
				<div className='w-full flex justify-center mt-10'>
					<span className='text-[#747681] text-sm md:text-base text-center'>
						<a href='/bites/contact-us' className='underline '>
							Contact Us
						</a>{" "}
						for any queries or feedback related to Bites.
					</span>
				</div>
			</div>
		</SimpleWrapper>
	);
}
